<template>
    <div class="mb-4 row" v-if="statuses != null && ordersByStatus != null">

        <div class="col-lg-12 col-md-12">
            <!--<transition name="fade">
                <div class="loading" v-show="loading">
                    <span class="fa fa-spinner fa-spin"></span> Loading
                </div>
            </transition>-->
            <div class="list-row" id="infinite-list">
                <template v-for="(orderByStatus, index) in ordersByStatus">
                    <div v-if="orderByStatus" class="customcolumn column"
                         :class="getStatusClass(orderByStatus.status)">
                        <div class="list-box">
                            <div class="inr-title" role="group">

                                <div class="d-flex">
                                    <div class="flex-grow-1">{{ orderByStatus.status.name }}</div>
                                    <div class="flex-shrink-0">
                                        <small class="badge bg-success align-bottom ms-1" >
                                            {{ orderByStatus.po_count }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="list-container" v-if="orderByStatus.purchaseOrders">
                                <draggable
                                    :id="'draggable_' + index"
                                    class="list-group"
                                    :list="ordersByStatus[index].purchaseOrders.data"
                                    draggable=".item"
                                    group="a"
                                    @change="handleChange($event, orderByStatus.status)"
                                >
                                    <div class="quote-list item"
                                         v-for="(item, itemIndex) in ordersByStatus[index].purchaseOrders.data"
                                         :id="item.id"
                                         :key="item.id"
                                         :class="{'mark-as-important': item.priority == 1}">
                                        <div class="white-bg quote-block">
                                            <div class="quote-header">
                                                <div class="quote-header-title">

                                                    <div class="q-nmbr">
                                                        <router-link :to="{ name: 'purchaseOrderShow', params: { id: item.id }}"
                                                                     class="quote_view">
                                                            #{{ item.po_number }}
                                                        </router-link>
                                                        <span v-if="item.parent_id" class="badge badge-soft-danger align-bottom ms-1" href="javascript:void(0)">Clone</span>
                                                        <span v-if="item.labels && item.labels.length" class="badge badge-soft-danger align-bottom ms-1" :style="'color:' + label.color" v-for="(label, index) in item.labels">{{label.name}}</span>
                                                        <template v-if="item.order && item.order.labels && item.order.labels.length">
                                                            <span class="badge badge-soft-danger align-bottom ms-1" :style="'color:' + label.color" v-for="(label, index) in item.order.labels">{{label.name}}</span>
                                                        </template>
                                                    </div>
                                                    <div class="item-name"></div>
                                                </div>
                                                <div class="quote-header-right">
                                                    <!--<a v-if="item.parent_id" class="badge badge-soft-danger align-bottom ms-1" href="javascript:void(0)">Clone</a>-->
                                                    <div class="btn-group">
                                                        <a href="javascript:void(0);" class="text-muted dropdown-toggle" :id="'dropdownMenuLink1_'+item.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="ri-more-fill"></i></a>
                                                        <ul class="dropdown-menu" :aria-labelledby="'dropdownMenuLink1_'+item.id">
                                                            <!--<li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-eye-fill align-bottom me-2 text-muted"></i> View</a></li>
                                                            <li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-edit-2-line align-bottom me-2 text-muted"></i> Edit</a></li>-->
                                                            <li v-if="item.priority != 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 1)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Mark Important</a></li>
                                                            <li v-if="item.priority == 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 0)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Un-mark Important</a></li>
                                                            <li><a class="dropdown-item"  href="javascript:void(0);" v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('delete-purchase-order')" @click="removeItem(item.id)"><i class="ri-delete-bin-5-line align-bottom me-2 text-muted"></i> Delete</a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="content-section">
                                                <div class="total-cost">Total: ${{numberWithCommas(item.amount)}}</div>
                                                <div class="customer-name">
                                                    <b>Vendor :</b>
                                                    <router-link v-if="item.vendor" target="_blank" :to="{ name: 'vendorDetails', params: { id: item.vendor_id }}">{{
                                                        item.vendor ? item.vendor.company_name : ''
                                                    }} ,
                                                    ({{
                                                        item.vendor && item.vendor.contacts && item.vendor.contacts.length ? item.vendor.contacts[0].contact_name : ''
                                                    }})
                                                    </router-link>
                                                </div>
                                                <div class="customer-name">
                                                    <b>Customer :</b>
                                                    <router-link v-if="item.order && item.order.customer" target="_blank" :to="{ name: 'customerDetails', params: { id: item.order.customer.id }}">{{
                                                        item.order.customer ? item.order.customer.company_name : ''
                                                    }} 
                                                    </router-link>
                                                </div>
                                                <div class="user-name"><b>Added By: </b>
                                                    {{ item.added_by ? item.added_by.name : '' }}
                                                </div>
                                            </div>


                                        </div>
                                        <div class="quote-footer">
                                            <div class="d-flex">
                                                <div class="flex-grow-1">
                                                    <small class="text-muted mb-0 fw-bold" :title="item.created_at_time">Created: <span :title="item.created_at_time">
                                                    {{ item.created_at_date }}
                                                </span></small>
                                                </div>
                                                <div class="flex-shrink-0">
                                                    <small class="text-muted mb-0 fw-bold" :title="item.updated_at_time">Updated: <span :title="item.updated_at_time">
                                                    {{ item.updated_at_date }}
                                                </span></small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </draggable>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import draggable from 'vuedraggable';
import {debounce, merge} from 'lodash';
import Vue from "vue";

export default {
    name: "PurchaseOrderGrid",
    components: {draggable},
    props: ['search_filter', 'bus', 'filterData'],
    created() {
        this.getOrderStatuses();
    },
    beforeMount() {
        this.current_page = 1;
        this.loadedScrollAllPage = 0;
        this.ordersByStatus = [];
    },
    mounted() {
        let self = this;
        if (this.filterData) {
            this.filterForm = this.filterData;
        }

        this.getOrders(this);

        this.bus.$on('getOrders', () => {
            self.current_page = 1;
            self.getOrders(this);
        });
        /*const listElm = document.querySelector('#infinite-list');

        listElm.addEventListener('scroll', e => {
            if(listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                this.current_page += 1;
            }
        });*/
        window.onscroll = () => {
            let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
            if (bottomOfWindow && this.loadedScrollAllPage == 0) {
                this.current_page += 1;
            }
        }
    },
    data() {
        return {
            orderData: null,
            total: 0,
            current_page: 1,
            loadedScrollAllPage: 0,
            filterForm: {
                purchase_search: null,
                search_saleuser_id: null,
                search_vendor_id: null,
                search_added_user_id: null,
                search_by_date: null,
                search_status_Id: null,
                date_range: null,
                label_id: null
            },
            statuses: [],
            ordersByStatus: [],
            dragging: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading'
        ]),
        goToView(id) {
            this.$router.push({name: 'purchaseOrderShow', params: {id: id}});
        },
        changePriority(id, priority){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('po.changePriority', {id: id, priority: priority}), {}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.getOrders(self);
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        removeItem(id){
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete order?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        this.$emit('deleteItem', {id: id});
                    }

                }
            })
        },
        getStatusClass(status) {
            let index = this.statuses.findIndex((x) => x.id == status.id);
            if (index > -1) {
                return 'column' + (index + 1);
            }
            return "";
        },
        getOrdersByStatus(status) {
            return this.orderData ? this.orderData[status.name.toLowerCase().replace("/", "-").replace(/\s+/g, '-')] : null;
        },
        handleChange(event, status) {
            if(event.added && ((this.getUser!= null && this.getUser.user_type == 1) || this.hasRole('Admin'))) {
                //console.log('changed', event.added.element.id);
                //console.log('changed-st', status.id);
                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.put(window.route('po.updateStatus', {id: event.added.element.id}), {status_id: status.id}, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({data}) => {
                        if (data.errorMessage) {
                            self.setErrorMessage(data.errorMessage);
                            if (data.errors) {
                                self.setCommonErrors(data.errors);
                            }
                        } else {
                            self.setSuccessMessage(data.message);
                            self.getOrders(this);
                            setTimeout(() => {
                                self.setSuccessMessage(null);
                            }, 5000);
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setLoading(false);

                    });
            } else {
                this.getOrders(this);
            }
        },
        getOrders: debounce((vm) => {
            let self = vm;// this;
            vm.setLoading(true);
            vm.setCommonErrors([]);
            vm.setErrorMessage(null);
            return axios.get(window.route('purchase-orders.index', {
                page: vm.current_page,
                purchase_search: vm.filterForm.purchase_search,
                search_status_Id: vm.filterForm.search_status_Id,
                search_added_user_id: vm.filterForm.search_added_user_id,
                search_vendor_id: vm.filterForm.search_vendor_id,
                search_saleuser_id: vm.filterForm.search_saleuser_id,
                search_by_date: vm.filterForm.search_by_date,
                date_range: vm.filterData.date_range,
                list_type: 'grid',
                label_id: vm.filterForm.label_id,
            }), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        vm.orderData = data.data;
                        vm.total = data.data.total;

                        if(vm.current_page <= 1) {
                            vm.ordersByStatus = [];
                        }
                        let loadedScrollAllPage = 0;
                        vm.statuses.filter((x) => x.grid_active == 1).forEach((x, index) => {
                            let orderByStatus = vm.getOrdersByStatus(x);
                            if (orderByStatus) {
                                if(vm.current_page > 1 && vm.ordersByStatus[index]) {
                                    loadedScrollAllPage += orderByStatus.purchaseOrders.data.length;
                                    //vm.ordersByStatus[index].purchaseOrders.data = _.merge(_.keyBy(vm.ordersByStatus[index].purchaseOrders.data, 'id'), _.keyBy(orderByStatus.purchaseOrders.data, 'id'));
                                    vm.ordersByStatus[index].purchaseOrders.data = vm.ordersByStatus[index].purchaseOrders.data.concat(orderByStatus.purchaseOrders.data);
                                } else {
                                    vm.ordersByStatus.push(orderByStatus);
                                }

                            } else {
                                vm.ordersByStatus.push({
                                    purchaseOrders: {data: []},
                                    so_count: 0,
                                    status: x
                                });
                            }

                        });
                        if(vm.current_page > 1) {
                            vm.loadedScrollAllPage = loadedScrollAllPage == 0 ? 1 : 0;
                        }

                        vm.$emit('returnTotalNumOrders', data.data.total);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        }, 350),
        getOrderStatuses() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('purchase-orders-status.index', {}), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.statuses = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        cloneOrder(id) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('po.clone', {id: id}), {}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.setSuccessMessage(data.message);
                        self.getOrders(this);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

    },
    watch: {
        current_page: {
            handler: function (value) {
                if (value != 1) {
                    this.getOrders(this);
                }
            }
        },
        search_filter: {
            handler: function (value) {
                this.filterForm.search_filter = value;
            }
        },
        filterData: {
            handler: function (value) {
                this.filterForm = value;
            }
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading'
        ])
    }
}
</script>

<style scoped>

</style>
